import { DISTRICT_ID } from './constants';

type LocationWithGroup = { locationGroupId: string };

export const cityHasRegions = (locations?: LocationWithGroup[] | null) =>
  !!locations?.some(location => location.locationGroupId === DISTRICT_ID);
